<script>
import AuthMixins from '@/mixins/AuthMixins';
import ls from 'localstorage-slim'

export default {
	mixins: [AuthMixins],

  data() {
		return {
			key: 'escRecommendedJobs',
      queryString: '?mode=job-match',
			loading: true,
			forcedFresh: false, // Set this to true to ensure it fetches fresh data on every page load.
			lastModified: false
		}
	},

	mounted() {
		if (this.manager) {
			// If we have nothing stored in localstorage, fetch some new recommendations from Algolia based on the user preferences.
			this.lastModified = (this.$store.getters.getUser['last-modified-preferences'] !== undefined) ? this.$store.getters.getUser['last-modified-preferences'] : false;

			let temp = this.getRecommended();
			if (temp === null || this.forcedFresh) {
				this.setRecommended({
					'lastModified': '',
					'index': 0,
					'jobs': []
				});
				this.performPreferenceSearch();
			} else {
				if (temp['lastModified'] !== this.lastModified) {
					this.performPreferenceSearch();
				} else {
					this.loading = false;
				}
			}
		}
  },

	methods: {
		getRecommended() {
      return ls.get(this.key);
    },
    setRecommended(value) {
      return ls.set(this.key, value, { ttl: 60*60*24 });
    },
		performPreferenceSearch() {
			let payload = {}
			return this.$api.loadRecommendedJobs(payload).then(
				(response) => {
					console.log(response.data);
					if (response.data.status == 'success') {
						let newJobs = response.data.jobs
						let current = this.getRecommended()['jobs'];
						newJobs.forEach((newJob) => {
							let existing = current.find(c => c.objectID == newJob.objectID);
							if (existing) {
								newJob.seen = existing.seen;
							}
						})

						this.setRecommended({
							'lastModified': this.lastModified,
							'index': 0,
							'jobs': newJobs
						});
						this.emitter.emit('refresh:recommended:jobs');
						this.loading = false;
					}
				}
			).catch((response) => {
				console.log("Could not load recommended jobs.", response);
			});
		},

		calculate_link(job) {
			if (job['slug']) {
				return '/opportunity/' + job['slug'] + this.queryString;
			}
			if (job['objectID']) {
				return '/opportunity/redirect/' + job['objectID'] + this.queryString;
			}
			return '#';
		}
	},

	computed: {
		hasRecommendations() {
      return this.getRecommended === null ? false : true;
    },
		current_index() {
			let index = this.getRecommended().jobs.findIndex((j) => {
				return j.objectID == this.jobid;
			});
			return index + 1;
		},
		count() {
			return this.getRecommended().jobs.length;
		},
		all_seen() {
			let notSeen = this.getRecommended().jobs.filter((j) => {
				return j.seen == undefined || j.seen == false;
			});
			return notSeen.length == 0;
		}
	}
}
</script>
